import {
  Button,
  EmptyStateIllustration3,
  NoMatchingResultIllustration,
} from "ui";

type Props = {
  isFiltering?: boolean;
  addEnabled?: boolean;
  addButtonText?: string;
  tableName: string;
  emptyMessage?: string;
  searchEnabled?: boolean;
  hasSearchQuery?: boolean;
  removeAllFilters?: () => void;
  onAddItemClick?: () => void;
  addLink?: React.ReactNode;
  setAddOpen?: (arg: boolean) => void;
};

export default function NoResults(props: Props) {
  const {
    isFiltering,
    addEnabled,
    addButtonText,
    tableName,
    emptyMessage,
    removeAllFilters,
    onAddItemClick,
    addLink,
    setAddOpen,
    searchEnabled,
    hasSearchQuery,
  } = props;

  return (
    <div className="flex flex-col items-center pt-6">
      {isFiltering ? (
        <NoMatchingResultIllustration className="h-40 w-36" />
      ) : (
        <EmptyStateIllustration3 />
      )}

      <h3 className="text-md mb-1 mt-4 font-medium text-foundations-boldest">
        {isFiltering ? "No results" : `No ${tableName}`}
      </h3>
      <p className="mb-6 text-sm text-foundations-subtle">
        {isFiltering
          ? searchEnabled && hasSearchQuery
            ? "Try searching with prefixes only if you are trying to search for an item."
            : "Try tweaking or resetting your filters to find your result."
          : emptyMessage || `Get started by adding a new ${tableName}`}
      </p>
      {isFiltering ? (
        <Button variant="primary" onClick={removeAllFilters}>
          Reset filters
        </Button>
      ) : addLink ? (
        <>{addLink}</>
      ) : addEnabled ? (
        <Button
          variant="primary"
          onClick={() => {
            if (onAddItemClick) {
              onAddItemClick();
            } else if (setAddOpen) {
              setAddOpen(true);
            }
          }}
        >
          {addButtonText ? addButtonText : `Add ${tableName}`}
        </Button>
      ) : null}
    </div>
  );
}
